export default __webpack_public_path__ + "rss-feed-button.png";